<template>
  <div id="xietongbao">
    <!-- 侧边栏 左边 -->
    <div :class="classObj">
      <component
        :is="leftMenuName"
        ref="leftMenu"
        :class="{ 'sidebar-container': leftMenuType() === '2' }"
        :style="{ backgroundColor: leftMenuStyle('backgroundColor') || '#34495e' }"
      />
    </div>
    <div class="meauContent" :style="{ width: meauContentStyle().width }">
      <div class="head">
        <MainHeader ref="childBreadcrumb" style="height: 50px" @isshow="isshow" />
      </div>
      <customTabs v-if="useTabsLayout"></customTabs>
      <div :class="['rightContent', useTabsLayout ? 'lowHeight' : '']">
        <div v-if="showSubMenu" :class="classObj" class="box" :style="{ width: boxStyle().width, left: boxStyle().left }">
          <div v-if="leftMenuName === 'leftMenu'" class="box1">
            <component
              :is="secondaryMenu"
              ref="secondaryMenu"
              :key="routeName"
              :route-name="routeName"
              :is-collapse="isCollapse"
              :defaultactive="defaultactive"
              :class-obj="classObj"
              :permission-key="permissionKey"
              :project-type="projectType"
              :user-router-list="userRouterList"
            />
          </div>
          <div v-if="leftMenuType() === '1'" class="box3" @click="toggleSideBar">
            <div v-if="classObj.hideSidebar == false" class="hide">
              <i class="el-icon-arrow-left"></i>
            </div>
            <div v-else class="open">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="box2">
            <router-view />
          </div>
        </div>
        <!-- 应用/消息/暂无项目 -->
        <div v-else class="box4">
          <router-view />
        </div>
      </div>
    </div>
    <flow-comp ref="flowDialogSummary" :mode="flowOptions.mode" :view="flowOptions.view"></flow-comp>
    <dynamicFormComp ref="dynamicForm" :formDialogOptions="formDialogOptions"></dynamicFormComp>
  </div>
</template>
<script>
import customTabs from "./components/customTabs.vue";
import flowComp from "@/CommonDP/components/processComponents/flow/flowDialogSummary.vue";
import dynamicFormComp from "@/CommonDP/components/dynamicFormDialog/index.vue";
import leftMenu from "@/CommonDP/components/leftMenu/leftMenu";
import leftFoldMenu from "@/CommonDP/components/leftFoldMenu/index";
import secondaryMenu from "@/CommonDP/components/secondaryMenu/secondaryMenu";
import MainHeader from "./header.vue";
import enterpriseService from "@/CommonDP/service/enterprise-service";
import { mapState } from "vuex";
import globalParams from "@/CommonDP/utils/globalParams";
import { uploader } from "@/CommonDP/utils/IUploader/dp.js";
export default {
  components: {
    leftMenu,
    MainHeader,
    secondaryMenu,
    leftFoldMenu,
    flowComp,
    dynamicFormComp,
    customTabs
  },
  data() {
    return {
      leftMenuName: "leftMenu",
      permissionKey: "",
      defaultactive: {
        path: ""
      },
      tox: "",
      prjname: "",
      logo: "",
      list: [],
      updateKey: 0,
      projectType: false,
      key: 1,
      NewsNumList: [],
      routeName: "",
      flowOptions: {
        mode: "edit",
        view: 2
      },
      formDialogOptions: {
        dialogTitle: "动态表单",
        dialogWidth: "1100px",
        dialogHeight: "710px"
      },
      useTabsLayout: false
    };
  },
  computed: {
    ...mapState({
      authRoutes: (state) => state.router.authRoutes,
      authProjectRoutes: (state) => state.router.authProjectRoutes,
      userInfo: (state) => state.user.userInfo,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      isShowMyEnterprise: (state) => state.projectMg.isShowMyEnterprise
    }),
    showSubMenu() {
      // 如果显示设置了不显示二级菜单，则不显示
      if (this.$route.meta.hideSubMenu) {
        return false;
      }
      // 如果显示设置了显示二级菜单，则显示
      if (this.$route.meta.showSubMenu) {
        return true;
      }
      // 没有设置的时候，才走默认的规则
      const needHide =
        this.$route.meta.pname === "应用" ||
        this.$route.meta.ppname === "应用" ||
        this.$route.meta.pppname === "应用" ||
        this.$route.meta.routeName === "暂无项目" ||
        this.$route.meta.routeName === "暂无权限";
      return !needHide;
    },
    secondaryMenu() {
      return "secondaryMenu";
    },
    showBar() {
      return this.$store.state.app.showBar;
    },

    sidebar() {
      return this.$store.state.app.sidebar;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened
      };
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
    userRouterList() {
      let list = [
        {
          name: "基本资料",
          icon1: require("@/CommonDP/assets/usercenter/data.svg"),
          icon2: require("@/CommonDP/assets/usercenter/data.svg"), //
          path: "/information"
        },
        {
          name: "修改头像",
          icon1: require("@/CommonDP/assets/usercenter/avator.svg"),
          icon2: require("@/CommonDP/assets/usercenter/avator.svg"), //
          path: "/modifyAvator"
        },
        {
          name: "修改密码",
          icon1: require("@/CommonDP/assets/usercenter/passworld.svg"),
          icon2: require("@/CommonDP/assets/usercenter/passworld.svg"), //
          path: "/modifyPassWorld"
        },
        {
          name: "更换手机号",
          icon1: require("@/CommonDP/assets/usercenter/phone.svg"),
          icon2: require("@/CommonDP/assets/usercenter/phone.svg"), //
          path: "/modifyPhone"
        },
        {
          name: "我的企业",
          icon1: require("@/CommonDP/assets/usercenter/qiye.svg"),
          icon2: require("@/CommonDP/assets/usercenter/qiye.svg"), //
          path: "/myEnterprise"
        }
      ];
      list = this.isShowMyEnterprise ? list : list.filter((str) => str.name !== "我的企业");
      return list;
    }
  },
  watch: {
    $route(newValue) {
      this.updateProjectType();
      if (this.$route.matched.at(-2)?.meta.useTemplate) {
        this.defaultactive.path = this.$route.matched.at(-2)?.meta.prouteName || this.$route.meta.routeName;
      } else {
        this.defaultactive.path = this.$route.meta.prouteName;
      }
      this.routeName = this.$route.meta.pname || this.$route.meta.ppname;
      this.initcur();
      this.$store.dispatch("unreadNum");
      if (this.$route.meta.pname === "消息") {
        this.$nextTick(() => {
          this.$refs.secondaryMenu && this.$refs.secondaryMenu.queryNewsNum();
        });
      }
    },
    enterpriseId(newValue) {
      this.judgeBranchOrg();
    }
  },
  created() {
    if (globalParams.get("leftMenuType") && globalParams.get("leftMenuType") === "2") {
      this.leftMenuName = "leftFoldMenu";
    }
    if (globalParams.get("useTabsLayout")) {
      this.useTabsLayout = true;
    }
    this.judgeCanCreateEnterprise();
    this.updateProjectType();
    if (this.$route.matched.at(-2)?.meta.useTemplate) {
      this.defaultactive.path = this.$route.matched.at(-2)?.meta.prouteName || this.$route.meta.routeName;
    } else {
      this.defaultactive.path = this.$route.meta.prouteName;
    }
    this.routeName = this.$route.meta.pname || this.$route.meta.ppname;
    this.querylist();
    this.judgeBranchOrg();
  },
  mounted() {
    var str = this.userInfo.name;
    this.tox = str && str.charAt(str.length - 1);
    if (this.$route.meta.pname === "消息") {
      this.$nextTick(() => {
        this.$refs.secondaryMenu && this.$refs.secondaryMenu.queryNewsNum();
      });
    }
  },
  provide() {
    return {
      openFlowDialog: this.openFlowDialog,
      openDynamicFromDialog: this.openDynamicFromDialog
    };
  },
  destroyed() {
    uploader.clear();
  },
  methods: {
    openFlowDialog(data, flowOptions) {
      flowOptions && (this.flowOptions = flowOptions);
      this.$refs.flowDialogSummary[flowOptions?.add ? "openAddDialog" : "openEditDialog"](data);
    },
    openDynamicFromDialog(data, formDialogOptions) {
      data = { formId: "2460684292849664", onlyRead: false, primaryKeyValue: "" };
      formDialogOptions && (this.formDialogOptions = formDialogOptions);
      this.$refs.dynamicForm.openDialog(data);
    },
    async judgeCanCreateEnterprise() {
      const res = await enterpriseService.judgeCanCreateEnterprise();
      this.$store.dispatch("setIsShowMyEnterprise", res.data);
    },

    updateProjectType() {
      if (this.$route.meta.routeName === "项目" || this.$route.meta.pname === "项目" || this.$route.meta.ppname === "项目") {
        this.projectType = true;
      } else if (this.$route.meta.pname !== "用户中心") {
        this.projectType = false;
      }
    },
    clickli(itemlist, name) {
      if (this.classObj.hideSidebar !== false) {
        this.$store.dispatch("toggleSideBar");
      }
    },

    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    async querylist() {
      // 企业列表 接口
      const res = await enterpriseService.usergetEnterpriseList();
      this.list = res.data;
    },
    initcur() {
      this.prjname = this.$store.state.projectMg.prjObj.prjName;
    },
    isshow(item) {
      this.permissionKey = item.permissionKey;
      if (item.name === "项目") {
        this.projectType = true;
        this.$refs.childBreadcrumb.refresh();
      } else {
        this.projectType = false;
      }
      this.updateProjectType();
    },

    leftMenuType() {
      return globalParams.get("leftMenuType");
    },

    leftMenuStyle(key) {
      const leftMenuStyle = globalParams.get("leftMenuStyle") || {};
      return leftMenuStyle[key];
    },

    meauContentStyle() {
      return {
        width: this.leftMenuType() === "1" ? "calc(100% - 68px)" : this.sidebar.opened ? `calc(100% - 210px)` : `calc(100% - 54px)`
      };
    },

    boxStyle() {
      return {
        width: this.leftMenuType() === "1" ? "100%" : `calc(100% - 30px)`,
        left: this.leftMenuType() === "1" ? "0" : `15px`
      };
    },
    async judgeBranchOrg() {
      const res = await enterpriseService.judgeBranchOrg(this.enterpriseId);
      this.$store.dispatch("setIsShowBranch", res.data);
    }
  }
};
</script>
<style lang="scss" scoped>
#xietongbao {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  .meauContent {
    min-width: 980px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .head {
      height: 50px;
      width: 100%;
    }
    .rightContent {
      width: 100%;
      height: calc(100% - 50px);
      position: relative;
      background-color: #eff1f6;
    }
    .lowHeight {
      height: calc(100% - 88px);
    }
  }
}
.main-box {
  width: 100%;
  height: calc(100% - 70px);
}
.box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-flow: row nowrap;
  align-content: stretch;
  margin: var(--middle-space) 0;
}
.box4 {
  position: relative;
  width: 100%;
  height: 100%;
}
.box1 {
  flex: 0 0 auto;
  background-color: #fff;
  overflow: hidden;
  transition: width 0.2s;
  border-radius: 4px;
  margin: 0 0 0 var(--middle-space);
  &:empty {
    display: none;
    & + .box3 {
      display: none;
    }
  }
}

.box2 {
  flex: 1 1 0px;
  position: relative;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 var(--middle-space);
}

// 按钮
.box3 {
  flex: 0 0 0;
}
.hide,
.open {
  position: absolute;
  top: 50%;
  line-height: 48px;
  width: 10px;
  border-radius: 0 12px 12px 0;
  background: #8c95a8;
  i {
    color: #fff;
    margin-left: -2px;
    font-size: 14px;
  }
}
.hide:hover {
  background: #4777e7;
  cursor: pointer;
}
.open:hover {
  background: #4777e7;
  cursor: pointer;
}
.openSidebar {
  .box1 {
    width: 130px;
  }
}
.hideSidebar {
  .box1 {
    width: 35px;
  }
}
.highlight {
  filter: grayscale(1);
}
</style>
